const topics = [
  { label: '动作大片', icon: 'ri-sword-line', hot: true },
  { label: '喜剧搞笑', icon: 'ri-emotion-happy-line', hot: false },
  { label: '科幻冒险', icon: 'ri-rocket-line', hot: true },
  { label: '浪漫爱情', icon: 'ri-heart-line', hot: false },
  { label: '悬疑推理', icon: 'ri-search-eye-line', hot: true },
  { label: '国产热剧', icon: 'ri-fire-line', hot: true },
  { label: '韩剧精选', icon: 'ri-kakao-talk-line', hot: false },
  { label: '美剧追踪', icon: 'ri-flag-line', hot: true },
  { label: '动漫番剧', icon: 'ri-ghost-line', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            话题标签
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门影视话题分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            按类型快速浏览您感兴趣的内容，发现更多精彩影视
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#"
              className="group relative flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              {topic.hot && (
                <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-[10px] font-bold whitespace-nowrap">
                  HOT
                </span>
              )}
              <div className="w-12 h-12 rounded-full bg-background-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${topic.icon} text-primary-500 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-foreground-800 text-sm font-medium group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            className="inline-flex items-center gap-2 text-foreground-600 hover:text-primary-600 text-sm font-medium transition-colors cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}